<div id="countdown" data-cy="countdown" >
  @if ((timeLeft$ | async); as t) {
    <div class="timer" data-cy="timer"> <!---->
      <div id="timeUntillLogout">
        @if (t.daysToDday > 0) {
          <span class="countdowntimer" id="days">{{t.daysToDday}}</span>
        }
        @if (t.daysToDday > 0) {
          <span class="countdowntimer2" id="days2">:</span>
        }
        @if (t.hoursToDday > 0 ) {
          <span class="countdowntimer" id="hours">{{t.hoursToDday.toString().padStart(2, '0')}}</span>
        }
        @if (t.hoursToDday > 0 ) {
          <span class="countdowntimer2" id="hours2">:</span>
        }
        @if (t.minutesToDday >= 0) {
          <span class="countdowntimer" id="minutes">{{t.minutesToDday.toString().padStart(2, '0')}}</span>
        }
        @if (t.minutesToDday >= 0) {
          <span class="countdowntimer2" id="minutes2">:</span>
        }
        @if (t.secondsToDday >= 0) {
          <span class="countdowntimer" id="seconds">{{t.secondsToDday.toString().padStart(2, '0')}} </span>
        }
        @if (t.secondsToDday >= 0) {
          <span class="countdowntimer2" id="seconds2"></span>
        }
      </div>
      @if (this.loggedoutMessageVisible) {
        @if (t.daysToDday <= 0 && t.hoursToDday <=0 && t.minutesToDday <= 0 && t.secondsToDday <= 0) {
          <span >Sie wurden ausgeloggt. <br/>
            Bitte wieder einloggen.
          </span>
        }
      }
    </div>
  }
</div>
